import { render } from "./ProfileInformationForm.vue?vue&type=template&id=3c1afcd4"
import script from "./ProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./ProfileInformationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__